<template>
  <div class="set-summary">
    <div class="summary-header">
      <div class="summary-title">Set {{ setNumber }} Summary</div>
      <div class="summary-actions">
        <button class="secondary" @click="$emit('undo-last-point')" :disabled="!canUndo">
          Undo Last Point
        </button>
        <button
          v-if="matchFinished"
          class="primary"
          @click="$emit('complete-match')"
        >
          Complete Match
        </button>
        <button class="primary" @click="$emit('start-next-set')" :disabled="!canStartNextSet">
          {{ canStartNextSet ? 'Start Next Set' : 'Match Finished' }}
        </button>
      </div>
    </div>
    <div class="summary-content">
      <div class="summary-view-tabs">
        <button
          class="tab-btn"
          :class="{ active: activeView === 'stats' }"
          @click="activeView = 'stats'"
        >
          Stats
        </button>
        <button
          class="tab-btn"
          :class="{ active: activeView === 'play' }"
          @click="activeView = 'play'"
        >
          Play-By-Play
        </button>
      </div>
      <PlayByPlayGrid
        v-if="activeView === 'play'"
        :playByPlay="setPoints"
        :current-lineup="setLineup"
      />
      <StatsDisplay
        v-else
        summary-mode
        :points="setPoints"
      />
    </div>
  </div>
</template>

<script>
import PlayByPlayGrid from './PlayByPlayGrid.vue';
import StatsDisplay from './StatsDisplay.vue';

export default {
  name: 'SetSummary',
  components: {
    PlayByPlayGrid,
    StatsDisplay
  },
  props: {
    setData: {
      type: Object,
      required: true
    },
    currentLineup: {
      type: Array,
      required: true
    },
    canStartNextSet: {
      type: Boolean,
      default: true
    },
    matchFinished: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeView: 'stats'
    };
  },
  computed: {
    setNumber() {
      return this.setData?.id ?? '';
    },
    setPoints() {
      return this.setData?.points || [];
    },
    setLineup() {
      return this.setData?.startingLineup || this.currentLineup;
    },
    canUndo() {
      return this.setPoints.length > 0;
    }
  }
};
</script>

<style scoped lang="scss">
.set-summary {
  position: fixed;
  inset: 0;
  background: var(--white);
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.summary-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--grey-25);
  background: var(--grey-5);
}

.summary-title {
  font-size: 16px;
  font-weight: 700;
}

.summary-actions {
  display: flex;
  gap: 8px;
}

.summary-content {
  flex: 1;
  overflow: auto;
  padding: 12px;
}

.summary-view-tabs {
  display: flex;
  gap: 6px;
  margin-bottom: 10px;
}

.tab-btn {
  background: var(--grey-20);
  border: none;
  border-radius: 8px;
  padding: 4px 10px;
  cursor: pointer;
  font-size: 12px;
}

.tab-btn.active {
  background: var(--red-accent);
  color: var(--white);
  font-weight: 700;
}

.primary {
  background: var(--red-accent);
  color: var(--white);
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  font-weight: 700;
}

.secondary {
  background: var(--grey-25);
  color: var(--grey-900);
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  cursor: pointer;
  font-weight: 700;
}

.primary:disabled,
.secondary:disabled {
  background: var(--grey-75);
  color: var(--grey-400);
  cursor: not-allowed;
}
</style>
